import { Image, Page, Text, View } from '@react-pdf/renderer';
import { coverImage } from './helper';
import { translations } from './interfaces';
import { FC } from 'react';
import { styles } from './styles';
import brandLogo from './images/brand-logo.png';

interface ICoverPage {
  translations: translations;
}
export const CoverPage: FC<ICoverPage> = ({ translations }) => (
  <Page orientation="landscape" style={[styles.page]}>
    <View style={{ height: '100%', width: '100%', position: 'relative' }}>
      <Image
        source={coverImage(translations)}
        style={[styles.backgroundImage]}
      />
      <View style={[styles.banner]}>
        <View style={[styles.bannerContent, styles.firstBanner]}>
          <Image source={brandLogo} style={{ maxWidth: '120px' }} />
          <View
            style={{
              marginLeft: '30px',
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <View
              style={{
                fontSize: '40px',
                margin: 0,
                color: '#fff',
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <Text style={{ fontWeight: 'bold' }}>{translations.cockpit}</Text>
              <Text
                style={{ fontWeight: 'normal' }}
              >{` ${translations.tiles}`}</Text>
            </View>

            <Text
              style={{
                fontSize: '20px',
                color: '#fff',
                fontWeight: 'light',
                marginLeft: 'auto'
              }}
            >{`${translations.version} - ${translations.themeTitle}`}</Text>
          </View>
        </View>
      </View>
    </View>
  </Page>
);
